import { ChildProps } from '@/common/util/props'

import Text from '@/components/view/atoms/text/Text'

const ChartTitle = ({ children }: ChildProps) => {
  return (
    <span className='absolute'>
      <Text weight='bold' size={14}>
        {children}
      </Text>
    </span>
  )
}

export default ChartTitle
